<template>
    <card-box>
        <card-title class="mb-3">
            Template
        </card-title>

        <div class="form-group">
            <label for="name">Template Name <em class="text-danger">*</em></label>
            <input id="name" v-model="template.name" name="name" required="required" type="text"
                   class="form-control">
        </div>

        <div class="form-group mt-3">
            <label for="style">Style</label>
            <select id="style" v-model="template.style" class="form-control" required="required">
                <option v-for="i in design.styles" :key="i.id" v-if="i.type == 1">{{i.name}}</option>
            </select>
        </div>
        <div class="form-group mt-3">
            <label class="d-block">Colors
            </label>
            <template v-for="color in styleColors">
                <button style="width: 80px" :key="color.id"
                        class="btn btn-sm m-1 ml-0 "
                        :class="{'selected': color.selected == true, 'border': (color.selected == false || color.selected == undefined)}"
                        :style="{ 'background-color': color.code, 'background-image': loadBackground(color.texture)}"
                        :title="color.name" @click="choiceColor(color)"><span class="text-shadow">{{color.name}}</span>
                </button>
            </template>
        </div>
        <div class="form-group mt-3">
            <label class="d-block">Sizes & Price <br>
                <small class="text-muted">Click Size name to select Size</small>
            </label>

            <div class="d-inline-flex">
                <template v-for="size in styleSizes">

                    <div class="input-group input-group-sm mr-2">
                        <div class="input-group-prepend">
                            <div @click="choiceSize(size)" :class="{'size-selected': size.selected == true}"
                                 class="pointer input-group-text">{{size.name}}
                            </div>
                        </div>
                        <input :class="{'size-selected': size.selected == true}" v-model="size.retail_price"
                               type="number"
                               class="form-control" placeholder="price">
                    </div>
                </template>
            </div>
        </div>


        <card-title class="mb-3 ">
            General
        </card-title>

        <div class="row">

            <div class="col">
                <div class="form-group">
                    <label for="brand_name">Brand Name <em class="text-danger">*</em></label>
                    <input id="brand_name" v-model="template.brand_name" name="brand_name" required="required"
                           type="text"
                           class="form-control">
                    <small class="form-text text-muted">Your brand name you registered with Amazon</small>
                </div>
            </div>
            <div class="col">

                <div class="form-group">
                    <label for="quantity">Quantity <em class="text-danger">*</em></label>
                    <input id="quantity" v-model="template.quantity" name="quantity" required="required" type="number"
                           class="form-control">
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label for="fulfillment_latency">Fulfillment Latency <em class="text-danger">*</em></label>
                    <input id="fulfillment_latency" v-model="template.fulfillment_latency" name="fulfillment_latency"
                           required="required" type="number"
                           class="form-control">
                </div>
            </div>
        </div>


        <div class="form-group">
            <label for="description">Product Description <em class="text-danger">*</em></label>

            <textarea rows="2" id="description" v-model="template.product_description" name="description"
                      required="required"
                      class="form-control"></textarea>
            <small class="form-text text-muted">Only alphanumeric characters (A-Z and 0-9) are recommended. <strong>[[NAME]]</strong>
                will be replaced with the product name.
            </small>


        </div>
        <hr>
        <card-title class="mb-3">
            Bullet Point
        </card-title>


        <div class="row">

            <div class="col-6">
                <div class="form-group">
                    <label for="bullet_point_1">Bullet Point 1</label>
                    <input id="bullet_point_1" v-model="template.bullet_point_1" name="bullet_point_1" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="bullet_point_2">Bullet Point 2</label>
                    <input id="bullet_point_2" v-model="template.bullet_point_2" name="bullet_point_2" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="bullet_point_3">Bullet Point 3</label>
                    <input id="bullet_point_3" v-model="template.bullet_point_3" name="bullet_point_3" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="bullet_point_4">Bullet Point 4</label>
                    <input id="bullet_point_4" v-model="template.bullet_point_4" name="bullet_point_4" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="bullet_point_5">Bullet Point 5</label>
                    <input id="bullet_point_5" v-model="template.bullet_point_5" name="bullet_point_5" type="text"
                           class="form-control">
                </div>
            </div>
        </div>

        <small class="form-text text-muted mb-3"><strong>[[NAME]]</strong> will be replaced with the product name.
        </small>
        <hr>
        <card-title class="mb-3">Generic Keyword</card-title>

        <div class="row">

            <div class="col-6">
                <div class="form-group">
                    <label for="generic_keyword_1">Generic Keyword 1</label>
                    <input id="generic_keyword_1" v-model="template.generic_keyword_1" name="generic_keyword_1"
                           type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="generic_keyword_2">Generic Keyword 2</label>
                    <input id="generic_keyword_2" v-model="template.generic_keyword_2" name="generic_keyword_2"
                           type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="generic_keyword_3">Generic Keyword 3</label>
                    <input id="generic_keyword_3" v-model="template.generic_keyword_3" name="generic_keyword_3"
                           type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="generic_keyword_4">Generic Keyword 4</label>
                    <input id="generic_keyword_4" v-model="template.generic_keyword_4" name="generic_keyword_4"
                           type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="generic_keyword_5">Generic Keyword 5</label>
                    <input id="generic_keyword_5" v-model="template.generic_keyword_5" name="generic_keyword_5"
                           type="text"
                           class="form-control">
                </div>
            </div>
        </div>
        <hr>
        <card-title class="mb-3">Other Image</card-title>

        <div class="row">

            <div class="col-6">
                <div class="form-group">
                    <label for="other_image_1">Other Image 1</label>
                    <input id="other_image_1" v-model="template.other_image_1" name="other_image_1" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="other_image_2">Other Image 2</label>
                    <input id="other_image_2" v-model="template.other_image_2" name="other_image_2" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="other_image_3">Other Image 3</label>
                    <input id="other_image_3" v-model="template.other_image_3" name="other_image_3" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="other_image_4">Other Image 4</label>
                    <input id="other_image_4" v-model="template.other_image_4" name="other_image_4" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="other_image_5">Other Image 5</label>
                    <input id="other_image_5" v-model="template.other_image_5" name="other_image_5" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="other_image_6">Other Image 6</label>
                    <input id="other_image_6" v-model="template.other_image_6" name="other_image_6" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="other_image_7">Other Image 7</label>
                    <input id="other_image_7" v-model="template.other_image_7" name="other_image_7" type="text"
                           class="form-control">
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="other_image_8">Other Image 8</label>
                    <input id="other_image_8" v-model="template.other_image_8" name="other_image_8" type="text"
                           class="form-control">
                </div>
            </div>
        </div>

        <div class="form-group">
            <button class="btn btn-primary" @click="updateTemplate()">
                Save Template
            </button>
        </div>
    </card-box>
</template>

<script>
    import CardBox from "./CardBox";
    import CardTitle from "./CardTitle";

    export default {
        name: "AmazonEditTemplate",
        components: {CardTitle, CardBox},

        data: function () {
            return {
                template: {},
                design: {},
                id: 0,
                colors: [],
                sizes: []

            }
        },
        mounted() {
            this.loadDesign()
        },
        computed: {
            styleColors: function () {
                if (this.template.style == null || this.template.style == undefined) return []
                let idx = this.$_.findKey(this.design.styles, {'name': this.template.style})

                if (idx) {
                    return this.design.styles[idx].colors
                }
                return []
            },
            styleSizes: function () {
                if (this.template.style == null || this.template.style == undefined) return []
                let idx = this.$_.findKey(this.design.styles, {'name': this.template.style})

                if (idx) {
                    return this.design.styles[idx].sizes
                }
                return []
            }
        },

        methods: {
            choiceColor: function (color) {
                let idx = this.$_.findKey(this.styleColors, {'id': color.id})
                if (color.selected == undefined || color.selected == false) {
                    this.$set(this.styleColors[idx], 'selected', true)
                } else {
                    this.$set(this.styleColors[idx], 'selected', false)
                }
            },
            choiceSize: function (size) {
                let idx = this.$_.findKey(this.styleSizes, {'id': size.id})
                if (size.selected == undefined || size.selected == false) {
                    this.$set(this.styleSizes[idx], 'selected', true)
                } else {
                    this.$set(this.styleSizes[idx], 'selected', false)
                }
            },
            loadIcon: function (icon) {
                if (icon == '') return ''
                icon = icon.replace('imgs/', '')
                return require('../assets/images/' + icon)
            },
            loadBackground: function (bg) {
                if (bg == '') return ''
                let img = bg.replace('imgs/', '')
                return 'url(' + require('../assets/images/' + img) + ')'

            },

            getColors: function () {
                let idx = this.$_.findKey(this.design.styles, {'name': this.template.style})
                if (idx) {

                }
            },
            getSizes: function () {
                let idx = this.$_.findKey(this.design, {sku: item.sku, style: this.product_style})
                if (!idx) {

                }
            },
            eventUpdate: function () {
                this.$emit('update', true);
            },
            updateTemplate: function () {
                let vm = this


                if (this.template.name == '' || this.template.name == undefined) {
                    this.$swal('Please enter Template name')
                    return false
                }
                if (this.template.style == '' || this.template.style == undefined) {
                    this.$swal('Please select style')
                    return false
                }


                let idx = this.$_.findKey(this.styleColors, {'selected': true})
                if (!idx) {
                    this.$swal('Please select Color')
                    return false
                }
                idx = this.$_.findKey(this.styleSizes, {'selected': true})
                if (!idx) {
                    this.$swal('Please select Size')
                    return false
                }

                for (let i = 0; i < this.styleSizes.length; i++) {
                    if (this.styleSizes[i].selected == true) {
                        if (this.styleSizes[i].retail_price == undefined || this.styleSizes[i].retail_price == '' || this.styleSizes[i].selected == 0 || this.styleSizes[i] == null) {
                            this.$swal('Please enter Price for Size ' + this.styleSizes[i].name)
                            return false
                        }
                    }
                }


                if (this.template.brand_name == '' || this.template.brand_name == undefined) {
                    this.$swal('Please enter brand name')
                    return false
                }
                if (this.template.quantity == '' || this.template.quantity == undefined) {
                    this.$swal('Please enter quantity')
                    return false
                }
                if (this.template.product_description == '' || this.template.product_description == undefined) {
                    this.$swal('Please enter description')
                    return false
                }
                if (this.template.fulfillment_latency == '' || this.template.fulfillment_latency == undefined) {
                    this.$swal('Please enter fulfillment latency')
                    return false
                }

                this.template.sizes = []
                for (let i = 0; i < this.styleSizes.length; i++) {
                    if (this.styleSizes[i].selected == true) {
                        this.template.sizes.push({
                            size: this.styleSizes[i].name,
                            price: this.styleSizes[i].retail_price
                        })
                    }
                }
                this.template.colors = []
                for (let i = 0; i < this.styleColors.length; i++) {
                    if (this.styleColors[i].selected == true) {
                        this.template.colors.push({
                            id: this.styleColors[i].id,
                            color: this.styleColors[i].name
                        })
                    }
                }

                this.$http.put(this.$config.api + 'marketing/amazon/template', this.template).then(function () {
                    vm.$swal('Update successfully')
                    vm.eventUpdate()
                })
            },

            getTemplate: function (id) {
                let vm = this
                this.$http.get(this.$config.api + 'marketing/amazon/template/' + id).then(function (res) {
                    vm.template = res.data
                    let colors = []
                    let sizes = []
                    if (res.data.colors != null && res.data.colors != '') {
                        colors = JSON.parse(res.data.colors)
                    }
                    if (res.data.sizes != null  && res.data.colors != '') {
                        sizes = JSON.parse(res.data.sizes)
                    }
                    setTimeout(function () {

                        for (let i = 0; i < colors.length; i++) {
                            let idx = vm.$_.findKey(vm.styleColors, {name: colors[i].color})
                            if (idx) {
                                vm.$set(vm.styleColors[idx], 'selected', true)
                            }
                        }

                        for (let i = 0; i < sizes.length; i++) {
                            let idx = vm.$_.findKey(vm.styleSizes, {name: sizes[i].size})
                            if (idx) {
                                vm.$set(vm.styleSizes[idx], 'selected', true)
                                vm.$set(vm.styleSizes[idx], 'retail_price', sizes[i].price)
                            }
                        }


                    }, 0)

                })
            },

            loadDesign: function () {
                let vm = this
                this.$http.get(this.$config.api + 'design').then(function (res) {
                    vm.design = res.data

                });
            },

        }


    }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }

    .selected {
        border: 1px solid #39FF14;
    }

    .size-selected {
        border: 1px solid #39FF14;
    }

    .text-shadow {
        color: #fff;
        font-size: 0.7rem;

    }
</style>